import { commandDispatcher } from '@/_core/cqrs/commandDispatcher';
import { ICommand, ICommandResult } from '@/_core/cqrs/types/commands';

export const sendTrashCommand = async <TResult extends ICommandResult>(command: ICommand<TResult>): Promise<TResult> => {
    return await commandDispatcher.dispatchCommand(command);
};
